import { render } from "./HomeView.vue?vue&type=template&id=3b88e2ae"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=3b88e2ae&lang=css"

import exportComponent from "/Users/jk/moen-digital-service-status/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__